import { environment } from '~env/environment';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

export const API_SEARCH_SUGGESTIONS_ROUTE_V3 = () => `${environment.svcSearch2BaseUrl()}/api/v3/suggestions`;
export const API_BUYER_PROMO_CATEGORIES = () =>
  `${environment.svcBuyerCategories()}/api/categories?flat=1&onlyWithPromotions=1`;
export const DEFAULT_OFFSET = 0;
export const DEFAULT_LIMIT = 40;
export const DEFAULT_HUB_LIMIT = 8;

export const MULTIMARKETS_CENTRAL_REGIONS = () =>
  `${environment.multiMarketsCentral()}`;

